import { maxInt } from '../helpers';

class Outcome {
  constructor(rawObj) {
    this.id = rawObj.id;
    this.name = rawObj.name;
    this.idBet = rawObj.bet.id;
    this.position = parseInt(rawObj.position, 10) || maxInt;
  }
}

export default Outcome;
